import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'util-profile-image',
  template: `<div class="profile-image" [ngClass]="size">
  <div class="shaper">
      <img [src]="imageUrl" />
  </div>
</div>
`,
  styles: [`.profile-image{overflow:hidden;width:60px;height:60px}.profile-image>.shaper{width:100%;height:100%;border:1px solid #fff;border-radius:50%;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.profile-image img{width:100%;vertical-align:inherit}.profile-image.xs{width:30px;height:30px}.profile-image.sm{width:45px;height:45px}.profile-image.md{width:60px;height:60px}.profile-image.lg{width:75px;height:75px}`]
})
export class ProfileImageComponent {
  @Input() userId: string;
  @Input() src: string;
  @Input() size: string;

  public get imageUrl(): string {
    if (this.src) return this.src;
    if (this.userId) return `http://wwwin.cisco.com/dir/photo/zoom/${this.userId}.jpg`;
  }
}
